import React, { memo, ReactNode } from 'react';

import { FaCheckSquare } from '@react-icons/all-files/fa/FaCheckSquare';
import { FaRegSquare } from '@react-icons/all-files/fa/FaRegSquare';

import { IFundChipsProps } from './ui-fund-chips.model';
import { FundStatusChip, CheckChip } from './styles';
import { FUND_STATUS_DICT, FUND_STATUS_LABEL } from './constants';
import { useTheme } from '@mui/material';

export const UiFundChips = memo(
  ({ fundHeader, mainColor }: IFundChipsProps) => {
    const theme = useTheme();

    const renderCheckIcon = (check: boolean): ReactNode => {
      return (
        <div
          style={{ marginLeft: '8px', alignItems: 'center', display: 'flex' }}
        >
          {check ? (
            <FaCheckSquare
              color={theme.palette.secondary.main}
              size={15}
              key="checkbox-enable"
            />
          ) : (
            <FaRegSquare size={15} key="checkbox" />
          )}
        </div>
      );
    };

    if (!fundHeader || !fundHeader.cvm_property) return null;

    const {
      open_condominium,
      qualified_investor,
      exclusive,
      long_term_tributation,
      pension_fund,
    } = fundHeader?.cvm_property;

    return (
      <ul
        data-testid="fund-chips"
        style={{
          padding: 0,
          marginTop: '8px',
          marginBottom: '8px',
          flexWrap: 'wrap',
          display: 'flex',
        }}
      >
        {fundHeader.status !== undefined && (
          <FundStatusChip
            status={FUND_STATUS_DICT[fundHeader.status]}
            data-testid="status"
          >
            <span>{FUND_STATUS_LABEL[fundHeader.status]}</span>
          </FundStatusChip>
        )}

        {open_condominium !== undefined && (
          <CheckChip
            maincolor={mainColor}
            checked={open_condominium}
            data-testid="open-condominium"
          >
            <span>CONDOMÍNIO ABERTO</span>
            {renderCheckIcon(open_condominium)}
          </CheckChip>
        )}

        {qualified_investor !== undefined && (
          <CheckChip
            maincolor={mainColor}
            checked={qualified_investor}
            data-testid="qualified-investor"
          >
            <span>INVESTIDOR QUALIFICADO</span>
            {renderCheckIcon(qualified_investor)}
          </CheckChip>
        )}

        {exclusive !== undefined && (
          <CheckChip
            maincolor={mainColor}
            checked={exclusive}
            data-testid="exclusive"
          >
            <span>EXCLUSIVO</span>
            {renderCheckIcon(exclusive)}
          </CheckChip>
        )}

        {long_term_tributation !== undefined && (
          <CheckChip
            maincolor={mainColor}
            checked={long_term_tributation}
            data-testid="long_term_tributation"
          >
            <span>TRIBUTAÇÃO DE LONGO PRAZO</span>
            {renderCheckIcon(long_term_tributation)}
          </CheckChip>
        )}
        {pension_fund !== undefined && (
          <CheckChip
            maincolor={mainColor}
            checked={pension_fund}
            data-testid="pension_fund"
          >
            <span>PREVIDÊNCIA</span>
            {renderCheckIcon(pension_fund)}
          </CheckChip>
        )}
      </ul>
    );
  }
);
